import React, { createContext, useContext, useEffect, useState } from 'react';
import { repeatEffect, settingsConfig } from 'utils/commonFunc';
import ApiService from 'services/ApiService';
import { defaultChartProps } from 'pages/components/CustomDashboardChart';

const TrafficTotalContext = createContext(null);

export function SwItsGetSmtTrfTotalProvider({ children }) {
    const [currentData, setCurrentData] = useState();

    useEffect(() => {
        return repeatEffect(async () => {
            const response = await ApiService.get("newdashboard/roadtraffic/GetSmtTrf");
            if (response.status === 200) {
                const data = response.data;

                const crossroadData = data.rows.map(row => ({
                    id: row.crsrdId,
                    name: row.crsrdNm,
                    value: row.todayValue ?? 0,
                }));

                setCurrentData({
                    crossroadData,
                    updateTime: data.updateTime,
                    unit: '대',
                });
            }
        }, settingsConfig().contentUpdateDelaySec);
    }, []);

    return (
        <TrafficTotalContext.Provider value={currentData}>
            {children}
        </TrafficTotalContext.Provider>
    );
}

export function SwItsGetSmtTrfTotalInfo() {
    const currentData = useContext(TrafficTotalContext);
    if (!currentData) return null;

    return (
        // <>
        //     {currentData.crossroadData.slice(0, 100).map(cross => (
        //         <div key={cross.id} className='gridLi flx a_center j_spc_btw'>
        //             <p className='rdNm'>{cross.name}</p>
        //             <div className='flx a_flx_end j_flx_end crtTrf'>
        //                 <span className='white' style={{ fontSize: 'var(--ft-36)', fontWeight:'var(--ft-Medium)', margin: '0 6px -4px 20px' }}>
        //                     {cross.value.toLocaleString()}
        //                 </span>
        //                 <span className='unit' style={{ fontSize: 'var(--ft-24)', marginBottom: '0' }}>대</span>
        //             </div>
        //         </div>
        //     ))}
        // </>
        <>
            <div className='trfGrid flx flx_col'>
                <div className='gridTitLi flx a_center j_spc_btw'>
                    <p className='rdNm'>교차로명</p>
                    <p className='crtTrf'>현재교통량</p>
                </div>
                <div className='gridBox cst_scroll'>
                    {currentData.crossroadData.slice(0, 100).map(cross => (
                        <div key={cross.id} className='gridLi flx a_center j_spc_btw'>
                            <p className='rdNm'>{cross.name}</p>
                            <div className='flx a_flx_end j_flx_end crtTrf'>
                                <span className='white' style={{ fontSize: 'var(--ft-36)', fontWeight: 'var(--ft-Medium)', margin: '0 6px -4px 20px' }}>
                                    {cross.value.toLocaleString()}
                                </span>
                                <span className='unit' style={{ fontSize: 'var(--ft-24)', marginBottom: '0' }}>대</span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
}